import { Auth } from "../store/common/auth";

export default function guest({ next, router }) {
  if (Auth.token) {
    return router.push({ name: "Home" });
  }

  return next();
}
